module.exports = __webpack_public_path__ + "img/feats-4.3ea7652d.jpg";